import { AnalyticsService } from '../../../typescript/common/analytics-service';
import { MunicipalitySelectorModalHelper } from '../../municipality-selector-modal/municipality-selector-modal.helper';
import './secondary-menu-desktop.scss';

(function secondaryMenuDesktop() {
  const searchMenuButtons: NodeListOf<HTMLElement> = document.querySelectorAll('[data-component="secondary-menu-desktop-search-button"]');
  const languageLinks: NodeListOf<HTMLElement> = document.querySelectorAll('[data-component="language-link-desktop"]');
  const loginMenuButtons: NodeListOf<HTMLElement> = document.querySelectorAll('[data-component="secondary-menu-desktop-login-menu-button"]');
  const municipalityMenuButtons: NodeListOf<HTMLElement> = document.querySelectorAll('[data-component="secondary-menu-desktop-municipality-menu-button"]');
  const municipalityNameMenuElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-component="secondary-menu-municipality-menu-button"]');

  if (searchMenuButtons || languageLinks || loginMenuButtons) {
    class SecondaryMenuDesktop {
      public init() {
        this.initSearchMenuButtons();
        this.initLoginMenuButtons();
        this.initLanguageLinks();
        this.initMunicipalityMenuButtons();
        this.initMunicipalityMenuName();
      }

      private initSearchMenuButtons() {
        if (!searchMenuButtons) {
          return;
        }

        searchMenuButtons.forEach((searchMenuButton) => {
          searchMenuButton.addEventListener('click', () => {
            if (!searchMenuButton.classList.contains('collapsed')) {
              setTimeout(() => {
                document.getElementById('search-autocomplete-desktop')?.focus();
              }, 200);
            }
            AnalyticsService.addEvent(AnalyticsService.HeaderCategory, 'Öppna/stäng sökfunktion');
          });
        });
      }

      private initLoginMenuButtons() {
        if (!loginMenuButtons) {
          return;
        }

        loginMenuButtons.forEach((loginMenuButton) => {
          loginMenuButton.addEventListener('click', () => {
            AnalyticsService.addEvent(AnalyticsService.HeaderCategory, 'Öppna/stäng inloggningsval');
          });
        });
      }

      private initLanguageLinks() {
        if (!languageLinks) {
          return;
        }

        languageLinks.forEach((languageLink) => {
          languageLink.addEventListener('click', () => {
            AnalyticsService.addEvent(AnalyticsService.HeaderCategory, 'Klick på språkval', languageLink.querySelector('.language-link-desktop__text')?.textContent?.trim());
          });
        });
      }

      private initMunicipalityMenuButtons() {
        if (!municipalityMenuButtons) {
          return;
        }

        municipalityMenuButtons.forEach((municipalityMenuButton) => {
          municipalityMenuButton.addEventListener('click', () => {
            AnalyticsService.addEvent(AnalyticsService.PaEgnaBenAdmin, 'Öppna kommunval');
            MunicipalitySelectorModalHelper.openMunicipalitySelectorModal();
          });
        });
      }

      private initMunicipalityMenuName() {
        if (!municipalityNameMenuElements.length) {
          return;
        }

        const selectedMunicipality = MunicipalitySelectorModalHelper.getSelectedMunicipalityFromCookies();
        if (
          selectedMunicipality &&
          selectedMunicipality.name !== MunicipalitySelectorModalHelper.NO_SELECTED_MUNICIPALITY_NAME &&
          selectedMunicipality.name !== municipalityNameMenuElements[0].textContent
        ) {
          municipalityNameMenuElements.forEach((element) => {
            const buttonElement = element;
            buttonElement.textContent = selectedMunicipality.name;
          });
        }
      }
    }

    const component = new SecondaryMenuDesktop();
    component.init();
  }
})();
